import { __assign } from "tslib";
import styled from "@emotion/styled";
export var IconWrapper = styled.span(function (_a) {
    var color = _a.color, height = _a.height, width = _a.width, _b = _a.wrapperCss, wrapperCss = _b === void 0 ? {} : _b;
    return (__assign(__assign({ display: "inline-block", flexShrink: 0, lineHeight: 1 }, wrapperCss), { color: color,
        height: height,
        width: width }));
}, function (_a) {
    var height = _a.height, width = _a.width, _b = _a.svgCss, svgCss = _b === void 0 ? {} : _b;
    return ({
        "> svg": __assign(__assign({ maxHeight: "100%", maxWidth: "100%", overflow: "hidden", pointerEvents: "none", verticalAlign: "bottom" }, svgCss), { height: height,
            width: width })
    });
});
IconWrapper.displayName = "IconWrapper";
//# sourceMappingURL=IconWrapper.js.map